// src/utils/logoutAndRedirect.js
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

/**
 * Faz logout do usuário autenticado e redireciona para a página de login.
 * @param {string} [redirectPath='/login'] Caminho para onde redirecionar. Pode incluir query string (?logout=true).
 */
export const logoutAndRedirect = async (redirectPath = '/login?logout=true') => {
  try {
    await signOut(auth);
    window.location.href = redirectPath;
  } catch (error) {
    console.error('Erro ao fazer logout:', error);
  }
};
